/* ==========================================================================
   Header-Suche: Lupe klicken -> Suchfeld fährt nach links aus,
   Live-Vorschläge über Shopifys Predictive Search API (/search/suggest.json),
   Enter -> normale Suchergebnisseite.
   Kein jQuery, kein Framework. Markup: sections/header.liquid
   ========================================================================== */
(function () {
  'use strict';

  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;
  var LIMIT = 6;

  /* ---------- Helfer ---------- */

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /* Suchbegriff im Titel hervorheben (nach dem Escapen, Wort für Wort) */
  function highlight(title, term) {
    var safe = escapeHtml(title);
    var words = term.split(/\s+/).filter(function (w) { return w.length > 1; });
    if (!words.length) return safe;
    var re = new RegExp('(' + words.map(escapeRegExp).join('|') + ')', 'ig');
    return safe.replace(re, '<mark>$1</mark>');
  }

  /* Bild-URL auf kleine Größe (Shopify CDN unterstützt ?width=) */
  function thumb(url, px) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + px;
  }

  /* Preis "59.99" -> "€59,99" gemäß shop.money_format */
  function money(amountStr, format) {
    var cents = Math.round(parseFloat(amountStr) * 100);
    if (isNaN(cents)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) { /* Fallback unten */ }
    }
    var num = cents / 100;
    function fmt(decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var out = format || '{{amount}}';
    out = out.replace('{{amount_no_decimals_with_comma_separator}}', fmt(0, '.', ','))
             .replace('{{amount_with_comma_separator}}', fmt(2, '.', ','))
             .replace('{{amount_no_decimals}}', fmt(0, ',', '.'))
             .replace('{{amount_with_apostrophe_separator}}', fmt(2, "'", '.'))
             .replace('{{amount}}', fmt(2, ',', '.'));
    return out;
  }

  /* ---------- Eine Header-Instanz initialisieren ---------- */

  function init(header) {
    var hs = header.querySelector('.hs');
    var toggle = header.querySelector('.hs-toggle');
    var panel = header.querySelector('[data-hs-panel]');
    if (!hs || !toggle || !panel || panel.getAttribute('data-hs-ready') === '1') return;
    panel.setAttribute('data-hs-ready', '1');

    var form = panel.querySelector('.hs-form');
    var input = panel.querySelector('.hs-input');
    var submit = panel.querySelector('.hs-submit');
    var results = panel.querySelector('.hs-results');
    var closeBtn = panel.querySelector('.hs-close');

    var searchUrl = panel.getAttribute('data-search-url') || '/search';
    var suggestUrl = (panel.getAttribute('data-suggest-url') || '/search/suggest') + '.json';
    var moneyFormat = panel.getAttribute('data-money-format') || '{{amount}}';

    var types = ['product'];
    if (panel.getAttribute('data-show-articles') === 'true') types.push('article');
    if (panel.getAttribute('data-show-pages') === 'true') types.push('page');

    var timer = null;
    var controller = null;
    var lastTerm = '';
    var activeIndex = -1;

    function isOpen() {
      return hs.classList.contains('is-open');
    }

    /* --- Öffnen / Schließen --- */

    function open() {
      hs.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      input.removeAttribute('tabindex');
      submit.removeAttribute('tabindex');
      input.focus();
      var term = input.value.trim();
      if (term.length >= MIN_CHARS) {
        search(term); // letzten Begriff beim Wiederöffnen direkt neu laden
      } else {
        results.innerHTML = '';
      }
    }

    function close() {
      abort();
      clearTimeout(timer);
      hs.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      input.setAttribute('tabindex', '-1');
      submit.setAttribute('tabindex', '-1');
      activeIndex = -1;
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen()) close(); else open();
    });

    closeBtn.addEventListener('click', function () {
      close();
      toggle.focus();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        close();
        toggle.focus();
      }
    });

    /* Klick außerhalb schließt */
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (hs.contains(e.target)) return;
      close();
    });

    /* --- Tippen -> Vorschläge --- */

    input.addEventListener('input', function () {
      clearTimeout(timer);
      activeIndex = -1;
      var term = input.value.trim();
      if (term.length < MIN_CHARS) {
        abort();
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(function () { search(term); }, DEBOUNCE_MS);
    });

    /* Pfeiltasten + Enter auf markierten Vorschlag */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Chrome leert type="search" bei Escape – Begriff behalten, nur schließen
        e.preventDefault();
        close();
        toggle.focus();
        return;
      }
      var items = results.querySelectorAll('.hs-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(items, activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(items, activeIndex - 1);
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        var link = items[activeIndex].querySelector('a');
        if (link) {
          e.preventDefault();
          window.location.href = link.href;
        }
      }
    });

    function setActive(items, idx) {
      if (idx < 0) idx = items.length - 1;
      if (idx >= items.length) idx = 0;
      for (var i = 0; i < items.length; i++) items[i].classList.remove('is-active');
      items[idx].classList.add('is-active');
      activeIndex = idx;
      if (items[idx].scrollIntoView) items[idx].scrollIntoView({ block: 'nearest' });
    }

    /* Enter / Lupe im Feld -> normale Suchseite (Form-Submit) */
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) {
        e.preventDefault();
        input.focus();
      }
    });

    /* --- Request --- */

    function abort() {
      if (controller) {
        try { controller.abort(); } catch (e) { /* egal */ }
        controller = null;
      }
    }

    function search(term) {
      abort();
      lastTerm = term;
      controller = window.AbortController ? new AbortController() : null;

      if (!results.querySelector('.hs-list')) {
        results.innerHTML = '<div class="hs-status">Suche …</div>';
      }

      var url = suggestUrl +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=' + types.join(',') +
        '&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, {
        signal: controller ? controller.signal : undefined,
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (term !== lastTerm) return; // veraltete Antwort
          var res = (data && data.resources && data.resources.results) || {};
          render(term, res);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          results.innerHTML = '<div class="hs-status">Vorschläge gerade nicht verfügbar – Enter drücken für die volle Suche.</div>';
        });
    }

    /* --- Rendering --- */

    function render(term, res) {
      var products = res.products || [];
      var others = (res.articles || []).concat(res.pages || []);
      var html = '';

      if (!products.length && !others.length) {
        results.innerHTML = '<div class="hs-empty">Keine Treffer für „' + escapeHtml(term) + '“</div>';
        return;
      }

      if (products.length) {
        html += '<div class="hs-group">Produkte</div><ul class="hs-list">';
        for (var i = 0; i < products.length; i++) html += productItem(products[i], term);
        html += '</ul>';
      }

      if (others.length) {
        html += '<div class="hs-group">Artikel &amp; Seiten</div><ul class="hs-list">';
        for (var j = 0; j < others.length; j++) {
          html += '<li class="hs-item"><a href="' + escapeHtml(others[j].url) + '">' +
            '<span class="hs-item__title">' + highlight(others[j].title, term) + '</span></a></li>';
        }
        html += '</ul>';
      }

      html += '<a class="hs-all" href="' + escapeHtml(searchUrl) +
        '?type=product&q=' + encodeURIComponent(term) + '">' +
        'Alle Ergebnisse für „' + escapeHtml(term) + '“ anzeigen →</a>';

      results.innerHTML = html;
      activeIndex = -1;
    }

    function productItem(p, term) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      var imgHtml = img
        ? '<img class="hs-item__img" src="' + escapeHtml(thumb(img, 88)) + '" alt="" width="44" height="44" loading="lazy">'
        : '<span class="hs-item__img"></span>';

      var priceMin = p.price_min || p.price;
      var priceMax = p.price_max || p.price;
      var compare = p.compare_at_price_min;
      var onSale = compare && parseFloat(compare) > parseFloat(priceMin);

      var priceHtml = '<span class="hs-item__price' + (onSale ? ' hs-item__price--sale' : '') + '">';
      if (onSale) priceHtml += '<span class="hs-item__compare">' + escapeHtml(money(compare, moneyFormat)) + '</span>';
      if (priceMin !== priceMax) priceHtml += 'ab ';
      priceHtml += escapeHtml(money(priceMin, moneyFormat)) + '</span>';

      var title = highlight(p.title, term);
      if (p.available === false) title += ' <small>(ausverkauft)</small>';

      return '<li class="hs-item"><a href="' + escapeHtml(p.url) + '">' +
        imgHtml +
        '<span class="hs-item__title">' + title + '</span>' +
        priceHtml +
        '</a></li>';
    }
  }

  /* ---------- Bootstrap ---------- */

  function initAll() {
    var headers = document.querySelectorAll('.header[data-section-type="header"]');
    for (var i = 0; i < headers.length; i++) init(headers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: Header-Section wird neu gerendert */
  document.addEventListener('shopify:section:load', function (e) {
    var header = e.target && e.target.querySelector ? e.target.querySelector('.header[data-section-type="header"]') : null;
    if (header) init(header);
  });
})();